<template>
	<div class="wrapper">
		<home-header></home-header>
		<div class="banner marginB-2">
			<img class="w100" src="../../assets/images/banner.png" alt="" />
		</div>
		<div class="widthwrap">
			<div class="txtcontent marginB-2">
				<h1 class="h2 title marginB-1">白相相品牌文化</h1>
				<!-- <p class="title2 t-cen marginT-2 fontSize18 marginB-2">消防评估 · 安全检查 · 设备管理 · 安防监控 · 教育培训</p> -->
				<p class="title3 t-cen fontSize14">通过长年累月的行业积淀，技术迭代，打造出一套更完善的智慧体育平台建设</p>
				<p class="title3 t-cen fontSize14">推动体育产业智慧化升级</p>				
			</div>
			<div class="txtcontent marginB-2">
				<h1 class="h2 title marginB-1">羽毛球星+球迷互动平台</h1>
				<p class="title2 t-cen marginT-2 fontSize18 marginB-2">全球顶级球星签约入驻</p>
				<p class="title3 t-cen fontSize14">实行候补制，根据排名，签约最新最热球星</p>
				<p class="title3 t-cen fontSize14">通过平台、APP推广（微信、微博、各类羽毛球俱乐部以及传统媒体）连接球迷</p>
				<p class="title3 t-cen fontSize14">享受运动快乐，引领运动社交，打造全方位羽毛球互动平台</p>
			</div>
			<iconlist></iconlist>
		</div>
		<home-footer></home-footer>
	</div>
</template>
<script>
	import HomeHeader from '@/components/header'
	import HomeFooter from '@/components/footer'
	import Iconlist from '@/pages/home/components/iconlist'
	export default {
		components: {
			HomeHeader,
			HomeFooter,
			Iconlist
		},
		methods:{
            /*detailsclick (){
                this.$router.push({
					path: `/solution/${item}`
				})
            }*/
        }
	}
</script>
<style lang="stylus" scoped>
	.banner{
		width: 100%;
		text-align: center;
		background: #ddd;
	}
	.title{
		width: 100%;
		font-size: 30px;
		font-weight: 500;
		font-family: "arial rounded mt bold";
		text-align: center;
		height: 80px;
		line-height: 80px;
		position: relative;
	}
	.title:after{
		content: "";
		position: absolute;
		left: 50%;
		margin-left: -50px;
		bottom: 0;
		width: 100px;
		height: 3px;
		background: -moz-linear-gradient(left, #0DC3B0,#0DC3B0);
	    background: -webkit-linear-gradient(left, #0DC3B0,#0DC3B0);
	    background: -o-linear-gradient(left, #0DC3B0,#0DC3B0);
	    background: -ms-linear-gradient(left, #0DC3B0,#0DC3B0);
	    background: linear-gradient(left, #0DC3B0,#0DC3B0);
	}
	.title2{
		line-height: 30px;
		color: #697B8C;
	}
	.title3{
		line-height: 30px;
		color: #333333;
	}
	.caselist{
		width: 100%;
		height: 800px;
		padding-top: 200px;
		background: url(../../assets/images/casebg.png) no-repeat top;
		background-size: 100% auto;
		.example{
			display: flex;
			justify-content: space-between;
			.item{
				width: 30%;
				height: 400px;
				padding: 30px;
			}
			.item1{
				background: url(../../assets/images/example-bg1.png) no-repeat bottom;
				background-size: 100% auto;
			}
			.item2{
				background: url(../../assets/images/example-bg2.png) no-repeat bottom;
				background-size: 100% auto;
			}
			.item3{
				background: url(../../assets/images/example-bg3.png) no-repeat bottom;
				background-size: 100% auto;
			}
		}
	}
	.cooperation{
		background: #FFFFFF;
		.companylist{
			display: flex;
			flex-wrap: wrap;
			.item{
				width: 16.5%;
				height: 180px;
				line-height: 150px;
				text-align: center;
				color: #A3B1BF;
				font-size: 20px;
				font-weight: 600;
			}
			.item img{
				width: 180px;
			}
		}
	}

	@media screen and (min-width:360px) and (max-width:480px) {
		.caselist .example .item{
			width: 33%;
		}
		.banner img{
			height: 100%;
		}
		.caselist,.caselist .example .item1,.caselist .example .item2,.caselist .example .item3{
			background-size: 100% 100%;
		}
		.page1-box-wrapper{
			margin-bottom: 1rem;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
		.page1-point-wrapper{
			display: none;
		}
		.cooperation .companylist .item img{
			width: 80%;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
	}
	@media screen and (min-width:480px) and (max-width:560px) {
		.caselist .example .item{
			width: 33%;
		}
		.banner img{
			height: 100%;
		}
		.caselist,.caselist .example .item1,.caselist .example .item2,.caselist .example .item3{
			background-size: 100% 100%;
		}
		.page1-box-wrapper{
			margin-bottom: 1rem;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
		.page1-point-wrapper{
			display: none;
		}
		.cooperation .companylist .item img{
			width: 80%;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
	}
	@media screen and (min-width:560px) and (max-width:640px) {
		.caselist .example .item{
			width: 33%;
		}
		.banner img{
			height: 100%;
		}
		.caselist,.caselist .example .item1,.caselist .example .item2,.caselist .example .item3{
			background-size: 100% 100%;
		}
		.page1-box-wrapper{
			margin-bottom: 1rem;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
		.page1-point-wrapper{
			display: none;
		}
		.cooperation .companylist .item img{
			width: 80%;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
	}
	@media screen and (min-width:640px) and (max-width:768px) {
		.caselist .example .item{
			width: 33%;
		}
		.banner img{
			height: 100%;
		}
		.caselist,.caselist .example .item1,.caselist .example .item2,.caselist .example .item3{
			background-size: 100% 100%;
		}
		.page1-box-wrapper{
			margin-bottom: 1rem;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
		.page1-point-wrapper{
			display: none;
		}
		.cooperation .companylist .item img{
			width: 80%;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
	}
	@media screen and (min-width:768px) and (max-width:1200px) {
		.banner img{
			height: 100%;
		}
		.caselist,.caselist .example .item1,.caselist .example .item2,.caselist .example .item3{
			background-size: 100% 100%;
		}
		.page1-box-wrapper{
			margin-bottom: 1rem;
		}
		.page1-box-wrapper li .page1-box{
			width: 100%;
		}
		.page1-point-wrapper{
			display: none;
		}
		.cooperation .companylist .item img{
			width: 98%;
		}
	}
	@media screen and (min-width:1200px) and (max-width:1700px) {
		.banner img{
			height: 100%;
		}
		.caselist,.caselist .example .item1,.caselist .example .item2,.caselist .example .item3{
			background-size: 100% 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue